import { Action, createReducer, on } from '@ngrx/store';
import {
  areaIsCreatedAction,
  removeRecentAreaAction
} from 'src/app/actions/area';

export interface AreaState {
  areas: any[];
  recentArea?: any | null;
}

export const initialState: AreaState = {
  areas: [],
  recentArea: null
};

const _areaReducer = createReducer(
  initialState,
  on(areaIsCreatedAction, (state, { newArea }) => ({
    ...state,
    areas: [...state.areas, newArea],
    recentArea: newArea
  })),
  on(removeRecentAreaAction, state => ({
    ...state,
    recentArea: null
  }))
);

export function areaReducer(state: AreaState | undefined, action: Action) {
  return _areaReducer(state, action);
}
